import React, { useEffect, useState } from 'react';
import { getAgentInterviewStatuses } from '../../../../api/search';
import Loader, { Types } from '../../../gdk/Loader';

export default function AgentStatusTable() {
    const [agentInterviewStatuses, setAgentInterviewStatuses] = useState();
    const [fetchFailed, setFetchFailed] = useState(false);

    useEffect(() => {
        getAgentInterviewStatuses()
            .then(response => { setAgentInterviewStatuses(response); })
            .catch(() => setFetchFailed(true));
    }, []);

    function sortTableByName() {
        setAgentInterviewStatuses(agentInterviewStatuses?.toSorted((a, b) => a.agentName.localeCompare(b.agentName)));
    }

    function sortTableByStatus() {
        setAgentInterviewStatuses(agentInterviewStatuses?.toSorted((a, b) => a.status.localeCompare(b.status)));
    }

    return (
        <>
            <gds-table>
                <gds-table-thead>
                    <gds-table-th data-onboarding-button-id="ApplicationStatus:AgentStatusTable:SortByProducerName" onClick={sortTableByName}>
                        Producer Name
                        <gds-icon icon-type="chevron-unsorted" size="xsmall"></gds-icon>
                    </gds-table-th>
                    <gds-table-th data-onboarding-button-id="ApplicationStatus:AgentStatusTable:SortByOnboardingStatus" onClick={sortTableByStatus}>
                        Onboarding Status
                        <gds-icon icon-type="chevron-unsorted" size="xsmall"></gds-icon>
                    </gds-table-th>
                </gds-table-thead>
                <gds-table-tbody>
                    {agentInterviewStatuses?.map((agentInterviewStatus) => (
                        <gds-table-tr key={agentInterviewStatus.agentName}>
                            <gds-table-td>{agentInterviewStatus.agentName}</gds-table-td>
                            <gds-table-td>{agentInterviewStatus.status}</gds-table-td>
                        </gds-table-tr>
                    ))}
                </gds-table-tbody>
            </gds-table>
            {agentInterviewStatuses?.length == 0 &&
                <p>No agent applications were found.</p>
            }
            {fetchFailed &&
                <p>There was a problem getting the agent application statuses.</p>
            }
            {!agentInterviewStatuses && !fetchFailed &&
                <Loader type={Types.Inline} />
            }
        </>
    );
}